import * as React from 'react';
import { Modal } from '@grandvisionhq/common';
import { useIntl, useDispatch, useSelector } from '@grandvisionhq/state';
import { selectStore, selectServiceStore } from '../../../actions.js';
import { getSelectedStore } from '../../../selectors.js';
import { StoresFinderContainer } from './StoresFinderContainer.js';
import { PickupLocationInformation } from '../components/PickupLocationInformation.js';
import { PickupWarningMessage } from '../components/PickupWarningMessage.js';

const PickupStoresContainer = ({ hideTitle =false , warningMessageOnly =false  })=>{
    const { getLabel  } = useIntl();
    const [modalIsOpen, setModalIsOpen] = React.useState(false);
    const dispatch = useDispatch();
    const selectedStore = useSelector(getSelectedStore);
    React.useEffect(()=>{
        if (!selectedStore) {
            setModalIsOpen(true);
        }
    }, [
        selectedStore
    ]);
    const onStoreSelect = (store)=>{
        if (!store) {
            return;
        }
        const serviceStore = {
            code: store.code,
            name: store.name,
            streetName: store.streetName,
            streetNumber: store.streetNumber,
            town: store.town
        };
        dispatch(selectStore({
            store
        }));
        dispatch(selectServiceStore({
            serviceStore
        }));
        setModalIsOpen(false);
    };
    const onPickupModalClose = ()=>{
        setModalIsOpen(false);
    };
    const onPickupModalShow = (event)=>{
        setModalIsOpen(true);
        event && event.preventDefault();
    };
    const labels = React.useMemo(()=>({
            storeFinderAction: getLabel('checkout.storeFinder.action'),
            noSelection: getLabel('checkout.store.selectStore.message'),
            noSelectionLink: getLabel('checkout.store.selectStore.link'),
            title: getLabel('checkout.store.title')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, modalIsOpen && /*#__PURE__*/ React.createElement(Modal, {
        className: "checkout-step--shipping__modal",
        showIcon: true,
        iconClassName: "checkout-step--shipping__modal__close",
        isOpen: modalIsOpen,
        onModalClose: onPickupModalClose
    }, /*#__PURE__*/ React.createElement(StoresFinderContainer, {
        onPickupStoreSelect: onStoreSelect
    })), selectedStore && !warningMessageOnly ? /*#__PURE__*/ React.createElement(PickupLocationInformation, {
        hideTitle: hideTitle,
        title: labels.title,
        location: selectedStore,
        onPickupModalShow: onPickupModalShow
    }) : /*#__PURE__*/ React.createElement(PickupWarningMessage, {
        labels: labels,
        onPickupModalShow: onPickupModalShow
    }));
};

export { PickupStoresContainer };
//# sourceMappingURL=PickupStoresContainer.js.map
